<template>
  <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header> Dados Básicos </v-expansion-panel-header>
          <v-expansion-panel-content style="font-size: 0.9em">
            <v-list dense>
              <v-list-item>Nome: {{ candidato.dadosPessoais.nome }}</v-list-item>
              <v-list-item
                >Nome Social:
                {{ candidato.dadosPessoais.nomeSocial }}</v-list-item
              >
              <v-list-item>CPF: {{ candidato.dadosPessoais.cpf | cpf_formatado}}</v-list-item>
              <v-list-item
                >Curso: {{ candidato.dadosPessoais.curso }}</v-list-item
              >
              <v-list-item
                >Modalidade:
                {{ candidato.modalidade }}</v-list-item
              >
              <v-list-item
                >PPI:
                {{ candidato.dadosPessoais.raca.descricao }}</v-list-item
              >
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header> Endereço </v-expansion-panel-header>
          <v-expansion-panel-content style="font-size: 0.9em">
            <v-list dense>
              <v-list-item
                >Logradouro:
                {{ candidato.endereco.logradouro }}</v-list-item
              >
              <v-list-item
                >Numero:{{
                  candidato.endereco.numero
                }}</v-list-item
              >
              <v-list-item
                >Complemento:
                {{ candidato.endereco.complemento }}</v-list-item
              >
              <v-list-item
                >Bairro:
                {{ candidato.endereco.bairro }}</v-list-item
              >
              <v-list-item
                >Municipio:
                {{ candidato.endereco.municipio }}</v-list-item
              >
              <v-list-item
                >CEP: {{ candidato.endereco.cep }}</v-list-item
              >
              <v-list-item
                >UF: {{ candidato.endereco.uf }}</v-list-item
              >
              <v-list-item
                >Pais: {{ candidato.endereco.pais }}</v-list-item
              >
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header> Contato </v-expansion-panel-header>
          <v-expansion-panel-content style="font-size: 0.9em">
            <v-list dense>
              <v-list-item
                >Telefone:
                {{ candidato.contato.telefone }}</v-list-item
              >
              <v-list-item
                >E-mail: {{ candidato.contato.email }}</v-list-item
              >
              <v-list-item
                >Contato de Urgência:
                {{
                  candidato.contato.contato_urgencia
                }}</v-list-item
              >
            </v-list>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
</template>


<script>

export default {
  props: {
    candidato: {
      type: Object,
      required: true,
    },
  }
};
</script>